const TIER_US = new Set([
  'US', 'USA', 'CA', 'CAN', 'GB', 'GBR', 'IL', 'ISR', 'JP', 'JPN',
  'AU', 'AUS', 'HK', 'HKG', 'NZ', 'NZL', 'SG', 'SGP',
]);

const TIER_A = new Set([
  'AT', 'AUT', 'BE', 'BEL', 'CY', 'CYP', 'DK', 'DNK', 'FI', 'FIN',
  'FR', 'FRA', 'DE', 'DEU', 'IS', 'ISL', 'IE', 'IRL', 'LU', 'LUX',
  'MT', 'MLT', 'NL', 'NLD', 'NO', 'NOR', 'SE', 'SWE', 'CH', 'CHE',
  'BH', 'BHR', 'KW', 'KWT', 'QA', 'QAT', 'SA', 'SAU', 'AE', 'ARE',
  'BN', 'BRN', 'KR', 'KOR', 'MO', 'MAC', 'TW', 'TWN',
]);

const TIER_B = new Set([
  'CZ', 'CZE', 'EE', 'EST', 'GR', 'GRC', 'HU', 'HUN', 'IT', 'ITA',
  'LV', 'LVA', 'LT', 'LTU', 'PL', 'POL', 'PT', 'PRT', 'SK', 'SVK',
  'SI', 'SVN', 'ES', 'ESP', 'MU', 'MUS', 'OM', 'OMN', 'SC', 'SYC',
  'ZA', 'ZAF', 'AR', 'ARG', 'BS', 'BHS', 'BB', 'BRB', 'CL', 'CHL',
  'CR', 'CRI', 'MX', 'MEX', 'PA', 'PAN', 'TT', 'TTO', 'UY', 'URY',
  'CN', 'CHN', 'KZ', 'KAZ', 'MY', 'MYS', 'TH', 'THA',
]);

const TIER_C = new Set([
  'AL', 'ALB', 'BY', 'BLR', 'BA', 'BIH', 'BG', 'BGR', 'HR', 'HRV',
  'ME', 'MNE', 'MK', 'MKD', 'RO', 'ROU', 'RU', 'RUS', 'RS', 'SRB',
  'TR', 'TUR', 'UA', 'UKR', 'DZ', 'DZA', 'AM', 'ARM', 'AZ', 'AZE',
  'BW', 'BWA', 'CV', 'CPV', 'EG', 'EGY', 'GA', 'GAB', 'GE', 'GEO',
  'IN', 'IND', 'IQ', 'IRQ', 'JO', 'JOR', 'LB', 'LBN', 'LY', 'LBY',
  'MA', 'MAR', 'NA', 'NAM', 'TN', 'TUN', 'BR', 'BRA', 'CO', 'COL',
  'DO', 'DOM', 'EC', 'ECU', 'PY', 'PRY', 'PE', 'PER', 'JM', 'JAM',
  'GY', 'GUY', 'SR', 'SUR', 'VE', 'VEN', 'BT', 'BTN', 'FJ', 'FJI',
  'ID', 'IDN', 'MV', 'MDV', 'MN', 'MNG', 'PH', 'PHL', 'LK', 'LKA',
  'VN', 'VNM',
]);

const TIER_D = new Set([
  'XK', 'XKX', 'XKK', 'MD', 'MDA', 'AF', 'AFG', 'AO', 'AGO', 'BJ',
  'BEN', 'BF', 'BFA', 'CM', 'CMR', 'TD', 'TCD', 'CD', 'COD', 'CG',
  'COG', 'CI', 'CIV', 'SZ', 'SWZ', 'GM', 'GMB', 'GH', 'GHA', 'GW',
  'GNB', 'KE', 'KEN', 'LR', 'LBR', 'MG', 'MDG', 'MW', 'MWI', 'ML',
  'MLI', 'MR', 'MRT', 'MZ', 'MOZ', 'NE', 'NER', 'NG', 'NGA', 'RW',
  'RWA', 'ST', 'STP', 'SN', 'SEN', 'SL', 'SLE', 'TZ', 'TZA', 'UG',
  'UGA', 'YE', 'YEM', 'ZM', 'ZMB', 'ZW', 'ZWE', 'AI', 'AIA', 'AG',
  'ATG', 'BZ', 'BLZ', 'BM', 'BMU', 'BO', 'BOL', 'VG', 'VGB', 'KY',
  'CYM', 'DM', 'DMA', 'SV', 'SLV', 'GD', 'GRD', 'GT', 'GTM', 'HN',
  'HND', 'MS', 'MSR', 'NI', 'NIC', 'KN', 'KNA', 'LC', 'LCA', 'VC',
  'VCT', 'TC', 'TCA', 'KH', 'KHM', 'KG', 'KGZ', 'LA', 'LAO', 'FM',
  'FSM', 'MM', 'MMR', 'NR', 'NRU', 'NP', 'NPL', 'PK', 'PAK', 'PW',
  'PLW', 'PG', 'PNG', 'SB', 'SLB', 'TJ', 'TJK', 'TO', 'TON', 'TM',
  'TKM', 'UZ', 'UZB', 'VU', 'VUT',
]);

export function getTierFromCountry(country: string | null | undefined): string {
  if (!country) return 'Unknown';
  const code = country.toUpperCase();
  if (TIER_US.has(code)) return 'US';
  if (TIER_A.has(code)) return 'A';
  if (TIER_B.has(code)) return 'B';
  if (TIER_C.has(code)) return 'C';
  if (TIER_D.has(code)) return 'D';
  return 'Unknown';
}
